<template>
  <div>
    <div v-for="polygon in options" :key="polygon?.id">
      <l-marker
        @click="selectVillages(polygon), $emit('village_data', polygon)"
        :lat-lng="polygon"
        ref="marker"
        @mouseout="closeLocalities"
        @mouseover="openPopup"
      >
        <l-popup
          class="map-popup"
          :content="`${polygon.displayName} ${'<br/>'}ID: ${polygon.id}`"
        ></l-popup>
        <l-icon>
          <img :src="polygon.icon" alt="" srcset="" />
        </l-icon>
      </l-marker>
    </div>
  </div>
</template>

<script>
import { LMarker, LIcon, LPopup } from "vue2-leaflet";
import L from "leaflet";
export default {
  components: {
    LMarker,
    LIcon,
    LPopup,
  },
  props: ["map", "options"],
  data() {
    return {
      polygons: [],
      is_active: true,
      customIcon: null,
      editingPolygonId: null,
      markers: [],
      numberPolygon: 0,
    };
  },
  methods: {
    refreshPolygon() {
      this.polygons = this.options.map((option) => ({
        id: option.id,
        vertices: option.polygon.coordinates[0].map((e) => ({
          id: ++this.numberPolygon,
          coords: [e[1], e[0]],
        })),
        polygonObject: null,
        editing: false,
        color: option.color,
        weight: option.lineWidth,
        editLatLng: false,
      }));
    },
    openPopup(event) {
      this.$refs.marker.forEach((e) => {
        if (e.latLng.lat == event.latlng.lat) {
          e.mapObject.openPopup(event.latlng);
        }
      });
    },
    closeLocalities(event) {
      this.$refs.marker.forEach((e) => {
        if (e.latLng.lat == event.latlng.lat) {
          e.mapObject.closePopup(event.latlng);
        }
      });
    },
    selectVillages(id, params) {
      if (id.id !== this.editingPolygonId) {
        this.clearData();
        this.createPolygon();
        this.$emit("isActivePolygonNP", id);
        this.colorPolygon(id);
      } else {
        if (params == "cancelEdit") {
          this.clearData();
          this.polygons = [];
          this.numberPolygon = 0;
          this.refreshPolygon();
          this.is_active = true;
          this.createPolygon();
          this.colorPolygon(id);
          this.selectPolygon(id.id);
        }
      }
    },
    colorPolygon(id) {
      this.polygons.forEach((e) => {
        if (e.id == id.id) {
          e.polygonObject.setStyle({
            color: "#ff3333",
            fillColor: "#ff3333",
          });
        } else {
          e.polygonObject.setStyle({
            color: "#3374FF",
            fillColor: "#3374FF",
          });
        }
      });
    },
    createPolygon() {
      this.refreshPolygon();
      if (this.is_active) {
        this.polygons.forEach((poly) => {
          const coords = poly.vertices.map((vertex) => vertex.coords);

          const polygon = L.polygon(coords, {
            color: poly.color,
            fillColor: poly.color,
            fillOpacity: 0,
            weight: poly.weight,
          }).addTo(this.map);

          poly.polygonObject = polygon;
          polygon.on("click", (e) => {
            if (!poly.editing) return; // реагируем только в режиме редактирования

            // 1) координаты полигона
            const latlngs = poly.vertices.map((v) => ({
              lat: v.coords[0],
              lng: v.coords[1],
            }));

            // 2) точка клика в слое
            const clickPt = this.map.latLngToLayerPoint(e.latlng);

            // 3) вычисляем ближайшее ребро
            const segIdx = this.getNearestSegmentIndex(
              latlngs,
              clickPt,
              this.map
            );
            if (segIdx === -1) return; // промахнулись — ничего не делаем

            // 4) формируем новую вершину
            const newId = ++this.numberPolygon;
            const vertex = { id: newId, coords: [e.latlng.lat, e.latlng.lng] };

            // 5) вставляем её в массив сразу после найденного ребра
            poly.vertices.splice(segIdx + 1, 0, vertex);

            // 6) визуально обновляем полигон
            poly.polygonObject.setLatLngs(poly.vertices.map((v) => v.coords));

            // 7) создаём маркер‑контроллер, как для остальных точек
            const marker = L.marker(e.latlng, {
              draggable: true,
              icon: this.customIcon, // у вас он уже создан в selectPolygon
            })
              .addTo(this.map)
              .on("click", () => this.removeMarker(poly, newId))
              .on("drag", (ev) => {
                const newPos = ev.target.getLatLng();
                poly.vertices.find((v) => v.id === newId).coords = [
                  newPos.lat,
                  newPos.lng,
                ];
                poly.polygonObject.setLatLngs(
                  poly.vertices.map((v) => v.coords)
                );
              })
              .on("drag", () => {
                this.$emit("coorModal", {
                  id: poly.id,
                  vertices: poly.vertices,
                  dragend: "dragend",
                });
              });

            this.markers.push(marker); // чтобы потом можно было удалить все разом
          });
        });
        this.is_active = false;
      }
    },
    getNearestSegmentIndex(latlngs, clickPt, map) {
      const EDGE_TOLERANCE = 8;
      let nearestSeg = -1;
      let minDist = Infinity;

      latlngs.forEach((latlng, i) => {
        const p1 = map.latLngToLayerPoint(latlng);
        const p2 = map.latLngToLayerPoint(latlngs[(i + 1) % latlngs.length]);
        const d = L.LineUtil.pointToSegmentDistance(clickPt, p1, p2);
        if (d < minDist) {
          minDist = d;
          nearestSeg = i;
        }
      });

      return minDist <= EDGE_TOLERANCE ? nearestSeg : -1;
    },
    deletePolygon() {
      this.polygons.forEach((e) => {
        if (e)
          e.polygonObject.remove(),
            (e.editLatLng = false),
            (this.is_active = true);
      });
    },
    clearData() {
      this.polygons.forEach((e) => {
        if (e.polygonObject !== null)
          e.polygonObject.remove(),
            (e.editLatLng = false),
            (this.is_active = true);
      });
      this.markers.forEach((e) => {
        if (e) e.remove();
      });
      this.markers = [];
      this.editingPolygonId = null;
    },
    selectPolygon(data) {
      const polygon = this.polygons.find((p) => p.id === data);

      if (!polygon) return;

      this.editingPolygonId = data;
      polygon.editing = true;

      this.$emit("coorModal", {
        id: data,
        vertices: polygon.vertices,
        dragend: "",
      });

      this.customIcon = L.divIcon({
        className: "custom-marker",
        html: '<div style="background-color: #ffff; width: 15px; height: 15px; border-radius: 10%; border: 2px solid black;"></div>',
        iconSize: [10, 10],
        iconAnchor: [10, 10],
      });

      this.markers.forEach((marker) => marker.remove());
      this.markers = [];

      polygon.vertices.forEach((coords) => {
        const marker = L.marker(coords.coords, {
          draggable: true,
          icon: this.customIcon,
        })
          .addTo(this.map)
          .on("click", () => this.removeMarker(polygon, coords.id));

        this.markers.push(marker);

        marker.on("drag", (e) => {
          const newPos = e.target.getLatLng();
          this.editLatLng = true;
          polygon.vertices.forEach((elem) => {
            if (coords.id == elem.id) {
              elem.coords = [newPos.lat, newPos.lng];
            }
          });
          const updatedCoords = polygon.vertices.map((vertex) => vertex.coords);
          polygon.polygonObject.setLatLngs(updatedCoords);
        });
        marker.on("drag", () => {
          this.polygons.map((p) => {
            if (p.editing) {
              this.$emit("coorModal", {
                id: data,
                vertices: polygon.vertices,
                dragend: "dragend",
              });
            }
          });
        });
      });
    },
    cancelEdit() {
      this.clearData();
      this.createPolygon();
    },
    removeMarker(polygon, id) {
      if (!polygon) return;
      polygon.vertices = polygon.vertices.filter((e) => e.id !== id);
      this.selectPolygon(polygon.id);
    },
    createMarker(e, poly, id) {
      let newPos = e.latlng;
      let number = ++this.numberPolygon;
      poly.vertices.push({ id: number, coords: [newPos.lat, newPos.lng] });
      const updatedCoords = poly.vertices.map((vertex) => vertex.coords);
      poly.polygonObject.setLatLngs(updatedCoords);
      this.selectPolygon(id);
    },
    undoСhanges(polyUndoChanges) {
      let polygonChanges = polyUndoChanges;
      this.selectVillages(polygonChanges[0], "cancelEdit");
    },
  },
};
</script>

<style>
.map-popup,
.leaflet-popup-content-wrapper {
  background: #000000b3;
  color: #fffbfb;
  box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);
}
.map-popup,
.leaflet-popup-content-wrapper,
.leaflet-popup-tip {
  background: #000000b3;
  color: #fffbfb;
  box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);
}
</style>
